{
  "name": "@postmortem-cli/mort",
  "version": "1.0.1",
  "description": "postmortem ☠ — AI-powered ops intelligence for developers",
  "type": "module",
  "bin": {
    "mort": "dist/index.js"
  },
  "engines": {
    "node": ">=22.0.0"
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "dev": "tsx src/index.ts",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "biome check .",
    "format": "biome format --write .",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@anthropic-ai/sdk": "^0.111.0",
    "better-sqlite3": "^12.0.0",
    "boxen": "^8.0.0",
    "chalk": "^5.6.0",
    "chokidar": "^5.0.0",
    "cli-table3": "^0.6.5",
    "commander": "^15.0.0",
    "fastify": "^5.8.0",
    "got": "^15.0.0",
    "ink": "^7.0.0",
    "kysely": "^0.29.0",
    "openai": "^6.0.0",
    "ora": "^9.0.0",
    "react": "^19.0.0",
    "smol-toml": "^1.0.0",
    "zod": "^4.0.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.0.0",
    "@types/better-sqlite3": "^7.6.0",
    "@types/node": "^24.0.0",
    "@types/react": "^19.0.0",
    "ink-testing-library": "^4.0.0",
    "msw": "^2.0.0",
    "tsup": "^8.5.0",
    "tsx": "^4.22.0",
    "typescript": "^6.0.0",
    "vitest": "^4.0.0"
  },
  "keywords": [
    "ops",
    "devops",
    "incident",
    "postmortem",
    "observability",
    "cli",
    "ai",
    "terminal",
    "vercel",
    "sre"
  ],
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/Baniloo-Labs/postmortem.git"
  },
  "homepage": "https://github.com/Baniloo-Labs/postmortem#readme",
  "bugs": {
    "url": "https://github.com/Baniloo-Labs/postmortem/issues"
  }
}
